import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import { useApp } from '@/presentation/hooks/use-app.js';

interface Props {
    value: string;
    onChange: (value: string) => void;
    error?: string;
    disabled?: boolean;
}

export function LinksTab({ value, onChange, error, disabled }: Props) {
    const { translate } = useApp();

    return (
        <Stack spacing={2}>
            <Box>
                <Typography variant="subtitle1" fontWeight={600}>
                    {translate('projects.tabs.links')}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {translate('projects.links.hint')}
                </Typography>
            </Box>
            <TextField
                fullWidth
                value={value}
                onChange={(e) => onChange(e.target.value)}
                label={translate('projects.tabs.links')}
                placeholder="https://exemplo.github.io/projeto"
                error={!!error}
                helperText={error ?? undefined}
                disabled={disabled}
            />
        </Stack>
    );
}
